/***
 * 创建人：段锐
 * 时间：2019-06-11
 * 描述：创建和销毁提供音频播放组件的服务
 * 更新说明:
 */
import { Injectable, Injector, ApplicationRef, ComponentFactoryResolver } from '@angular/core';
import { SwAudioComponent } from './sw-audio.component';
import { SwDestructionService } from 'src/app/librarys/serves/sw-destruction.service';

/**
 * 创建和销毁提供音频播放组件的服务
 */
@Injectable({
  providedIn: 'root'
})
export class SwAudioService {

   /**
   * @ignore
   */
  constructor(private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private SwDestructionService: SwDestructionService ///注入销毁组件的服务
  ) { }

  /**
   * 关闭加载框
   * @ignore
   */
  closeAudio() {
    //构造出组件
    const rootpop = document.createElement("sw-audio");
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwAudioComponent);
    const componentRef = factory.create(this.injector, [], rootpop);
    this.applicationRef.attachView(componentRef.hostView);
    //调用组件内的关闭方法
    componentRef.instance.closeAudio();
  }
  /**
   *  创建音频播放
   *  @param title 音频名称
   *  @param src 音频路径 绝对
   */
  openAudio(title: string, src: string) {
    //销毁之前的组件
    this.SwDestructionService.destruction("sw-audio");

    //构造出组件
    const rootpop = document.createElement("sw-audio");
    const factory = this.componentFactoryResolver.resolveComponentFactory(SwAudioComponent);
    const componentRef = factory.create(this.injector, [], rootpop);
    this.applicationRef.attachView(componentRef.hostView);

    componentRef.instance.voted.subscribe(() => {
      //销毁组件
      document.body.removeChild(rootpop);
      this.applicationRef.detachView(componentRef.hostView);
      componentRef.destroy()
    });

    //传递参数
    componentRef.instance.title = title;
    componentRef.instance.src = src;
    //调用组件内的打开方法
    componentRef.instance.openAudio();
    document.body.appendChild(rootpop);
  }
}
